export const GET_RECORDED_DATA = 'recordedData/getPatientRecordedData'
